import Axios from 'axios'
import VueFuse from 'vue-fuse'
const axios = Axios.create();
export default {

    state: {
        result: [],
        products: []

    },

    getters: {

        getProductsFormGetters(state){ //take parameter state

            return state.products
        }
    },

    actions: {
        allProductsFromDatabase(context){

            axios.get("/api/products")

                .then((response)=>{
                    context.commit("products",response.data.products) //categories will be run from mutation

                })

                .catch(()=>{

                    console.log("Error........")

                })
        }
    },

    mutations: {
        products(state,data) {
            return state.products = data
        }
    }
}
